angular.module('app.filters').filter('streamSourceName', ($filter) => {
  'ngInject';
  return (broadcast) => {
    switch (broadcast.stream_source) {
      case 'switcher':
        return 'Switcher Studio (iOS)';
      case 'app':
        return 'Broadcaster App';
      case 'rtmp':
        if (broadcast.static_rtmp_name) {
          return `RTMP: ${broadcast.static_rtmp_name}`;
        } else {
          return 'RTMP';
        }
      case 'srt':
        if (broadcast.srt_source_name) {
          return `SRT: ${broadcast.srt_source_name}`;
        } else {
          return 'SRT';
        }
      case 'recording':
        return 'Re-Broadcast (Simulated Live)';
      case 'producer':
        return 'Producer (Browser-based streaming)';
      default:
        return broadcast.boxcaster_name;
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/stream-source-name.js